import React from 'react';
import cn from 'classnames';
import Icon from 'components/UI/Icon';

import * as styles from './VideoDuration.module.scss';

export default function VideoDuration({ duration, className }) {
  return (
    <div className={cn(styles.duration, className)}>
      <Icon name="play-triangle" className={styles.smallPlay} />
      {duration}
    </div>
  );
}
